import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import * as ListEvidenceSelectors from './list-evidence-store.selectors';
import * as ListEvidenceActions from './list-evidence-store.actions';
import { IListEvidenceState } from './list-evidence-store.state';

import { TableData } from '@shared/ui/tables';
import { EvidenceBase } from '@shared/utils/evidence-management';

@Injectable({
  providedIn: 'root',
})
export class ListEvidenceFacade {
  public constructor(private readonly store: Store<IListEvidenceState>) {}

  public listEvidence(query: string): void {
    this.store.dispatch(ListEvidenceActions.listEvidence({ query: query }));
  }

  public sharedWithMeEvidence(query: string): void {
    this.store.dispatch(ListEvidenceActions.sharedWithMeEvidence({ query: query }));
  }

  public refreshEvidence(): void {
    this.store.dispatch(ListEvidenceActions.refreshEvidence());
  }

  public getEvidence(): Observable<TableData<EvidenceBase>> {
    return this.store.select(ListEvidenceSelectors.evidenceState).pipe(map((x) => new TableData(x.count, x.evidence)));
  }

  public getEvidenceSharedWithMe(): Observable<TableData<EvidenceBase>> {
    return this.store.select(ListEvidenceSelectors.evidenceState).pipe(map((x) => new TableData(x.sharedWithMeCount, x.sharedWithMeEvidence)));
  }

  public getEvidenceQuery(): Observable<string> {
    return this.store.select(ListEvidenceSelectors.evidenceQuery);
  }

  public getIsLoadingEvidence(): Observable<boolean> {
    return this.store.select(ListEvidenceSelectors.isLoading);
  }

  public isLoadingSharedWithMe(): Observable<boolean> {
    return this.store.select(ListEvidenceSelectors.isSharedWithMeLoading);
  }
}
